import React, { useEffect, useState } from "react";
import {
  Container,
  Col,
  FormGroup,
  Label
} from "reactstrap";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loading } from "../../share/loading";
import "../../share/form.css";
import "../../borrowSystem/Admin.css";
import "../../borrowSystem/BorrowForm/TabBorrowComponent.css";



export function ExtendBorrowDetailComponent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const trainTestId = searchParams.get("trainTestId");
  const [toggleState, setToggleState] = useState(1);
  const [loading, setLoading] = useState(false);
  // const [data, setData] = useState([]);
  const [newAddressdatas, setnewaddressdata] = useState([]);
  const [oldAddressdatas, setoldaddressdata] = useState([]);
  const [borrowDetaildatas, setborrowDetaildatas] = useState([]);
  const [newAddresstestdata, setnewAddresstestdata] = useState([]);
  const [oldAddresstestdata, setoldAddresstestdata] = useState([]);
  const [borrowDetailtestdata, setborrowDetailtestdata] = useState([]);

  const user = JSON.parse(localStorage.getItem("userData"));

  useEffect(() => {
    getdetailsupport();
    getdetailsupport2();
  }, []);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  async function getdetailsupport() {
    setLoading(true);
    let postData = new FormData();
    postData.append("borrowId", searchParams.get("req"));
    postData.append("trainTestId", trainTestId);

    try {
      let res = await fetch("/api/Borrow/getTrainAllDetail", {
        method: "POST",
        body: postData,
      });

      // });
      const data = await res.json();
      setnewaddressdata(data.dataenum.newAddressdatas);
      setoldaddressdata(data.dataenum.oldAddressdatas);
      setborrowDetaildatas(data.dataenum.borrowDetaildatas);
      console.log("dataalldetail", data.dataenum);
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }

  async function getdetailsupport2() {
    setLoading(true);
    let postData = new FormData();
    postData.append("borrowId", searchParams.get("req"));
    try {
      let res = await fetch("/api/Borrow/getTestAllDetail", {
        method: "POST",
        body: postData,
      });

      // });
      const data = await res.json();
      setnewAddresstestdata(data.dataenum.newAddresstestdata);
      setoldAddresstestdata(data.dataenum.oldAddresstestdata);
      setborrowDetailtestdata(data.dataenum.borrowDetailtestdata);
      console.log("dataalldetail", data.dataenum);
    } catch (e) {
      console.log("err =>" + e);
    } finally {
      setLoading(false);
    }
  }




  return (
    <>
      {/* tab */}
      <Container className="d-flex justify-content-center align-items-center mt-2 mb-4 tab-container">
        <div
          className={
            toggleState === 1
              ? "tab-item tab-item-active text-center"
              : "tab-item tab-item-non-active text-center"
          }
          // className="tab-item tab-item-active text-center"
          style={{ lineHeight: "3rem", cursor: "pointer" }}
          onClick={() => {
            toggleTab(1);
          }}
        >
          <span className="px-3">คำขอแจ้งเลื่อนการฝึกอบรม</span>
        </div>

        <div
          className={
            toggleState === 2
              ? "tab-item tab-item-active text-center"
              : "tab-item tab-item-non-active text-center"
          }
          style={{ lineHeight: "3rem", cursor: "pointer" }}
          onClick={() => {
            toggleTab(2);
          }}
        >
          <span className="px-3">คำขอแจ้งเลื่อนการทดสอบ</span>
        </div>
      </Container>

      <Container className="d-flex flex-column justify-content-center align-items-center">
        <div className="form-border">
          {!loading ? (
            <>
              <div className={toggleState === 1 ? "p-5 mb-4" : "non-active"}>
                {newAddressdatas || oldAddressdatas != null ? (
                  <div>
                    <FormGroup>
                      <Label className="">
                        ชื่อผู้ขอกู้ยืม :
                      </Label>
                      <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                        {borrowDetaildatas.borrowName
                          ? borrowDetaildatas.borrowName
                          : "-"}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <Label className="">ชื่อหลักสูตร :</Label>
                      <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                        {borrowDetaildatas.traincourseName
                          ? borrowDetaildatas.traincourseName
                          : "-"}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <Label className="">รุ่นที่ :</Label>
                      <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                        {borrowDetaildatas.class
                          ? borrowDetaildatas.class
                          : "-"}
                      </p>
                    </FormGroup>

                    {borrowDetaildatas.newstartDate != null ? (
                      <div>
                        <Label className="">วันที่ฝึกอบรม (เก่า)</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            วันที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetaildatas.oldstartDate
                                ? borrowDetaildatas.oldstartDate
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            ถึง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetaildatas.oldendDate
                                ? borrowDetaildatas.oldendDate
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                        <Label className="">วันที่ฝึกอบรม (ใหม่)</Label>

                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            วันที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetaildatas.newstartDate
                                ? borrowDetaildatas.newstartDate
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            ถึง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetaildatas.newendDate
                                ? borrowDetaildatas.newendDate
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    ) : (
                      <div>
                        <Label className="">วันที่ฝึกอบรม</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            วันที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetaildatas?.oldstartDate
                                ? borrowDetaildatas?.oldstartDate
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            ถึง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetaildatas?.oldendDate
                                ? borrowDetaildatas?.oldendDate
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    )}

                    {newAddressdatas?.newAddressNo != null ? (
                      <div>
                        <Label className="mt-1">สถานที่ฝึกอบรม (เก่า)</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            เลขที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas?.oldAddressNo
                                ? oldAddressdatas?.oldAddressNo
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            หมู่ที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas?.oldMoo
                                ? oldAddressdatas?.oldMoo
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="soi" sm={2}>
                            ซอย
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldSoi
                                ? oldAddressdatas.oldSoi
                                : "-"}
                            </p>
                          </Col>

                          <Label for="street" sm={2}>
                            ถนน
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldStreet
                                ? oldAddressdatas.oldStreet
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="province" sm={2}>
                            จังหวัด
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldProvince
                                ? oldAddressdatas.oldProvince
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            อำเภอ/เขต
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldAmphur
                                ? oldAddressdatas.oldAmphur
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="tumbon" sm={2}>
                            ตำบล/แขวง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldTumbon
                                ? oldAddressdatas.oldTumbon
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            รหัสไปรษณีย์
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldPostCode
                                ? oldAddressdatas.oldPostCode
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <Label className="mt-1">สถานที่ฝึกอบรม (ใหม่)</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            เลขที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas?.newAddressNo
                                ? newAddressdatas?.newAddressNo
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            หมู่ที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas?.newMoo
                                ? newAddressdatas?.newMoo
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="soi" sm={2}>
                            ซอย
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas?.newSoi
                                ? newAddressdatas?.newSoi
                                : "-"}
                            </p>
                          </Col>

                          <Label for="street" sm={2}>
                            ถนน
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas.newStreet
                                ? newAddressdatas.newStreet
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="province" sm={2}>
                            จังหวัด
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas.newProvince
                                ? newAddressdatas.newProvince
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            อำเภอ/เขต
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas.newAmphur
                                ? newAddressdatas.newAmphur
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="tumbon" sm={2}>
                            ตำบล/แขวง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas.newTumbon
                                ? newAddressdatas.newTumbon
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            รหัสไปรษณีย์
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddressdatas.newPostCode
                                ? newAddressdatas.newPostCode
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    ) : (
                      <div>
                        <Label className="mt-1">สถานที่ฝึกอบรม</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            เลขที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldAddressNo
                                ? oldAddressdatas.oldAddressNo
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            หมู่ที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldMoo
                                ? oldAddressdatas.oldMoo
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="soi" sm={2}>
                            ซอย
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldSoi
                                ? oldAddressdatas.oldSoi
                                : "-"}
                            </p>
                          </Col>

                          <Label for="street" sm={2}>
                            ถนน
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldStreet
                                ? oldAddressdatas.oldStreet
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="province" sm={2}>
                            จังหวัด
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldProvince
                                ? oldAddressdatas.oldProvince
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            อำเภอ/เขต
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldAmphur
                                ? oldAddressdatas.oldAmphur
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="tumbon" sm={2}>
                            ตำบล/แขวง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldTumbon
                                ? oldAddressdatas.oldTumbon
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            รหัสไปรษณีย์
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddressdatas.oldPostCode
                                ? oldAddressdatas.oldPostCode
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    )}


                  </div>
                ) : (
                  <div className="d-flex w-100 align-items-center justify-content-center">
                    <p>ไม่มีคำขอแจ้งเลื่อนการฝึกอบรม</p>
                  </div>
                )}



              </div>

              <div className={toggleState === 2 ? "p-5 mb-4" : "non-active"}>
                {newAddresstestdata || oldAddresstestdata != null ? (
                  <div>
                    <FormGroup>
                      <Label className="">
                        ชื่อผู้ขอกู้ยืม :
                      </Label>
                      <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                        {borrowDetailtestdata.borrowName
                          ? borrowDetailtestdata.borrowName
                          : "-"}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <Label className="">ชื่อสาขาอาชีพ :</Label>
                      <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                        {oldAddresstestdata.lawOcName
                          ? oldAddresstestdata.lawOcName
                          : "-"}
                      </p>
                    </FormGroup>
                    <FormGroup>
                      <Label className="">ครั้งที่ดำเนินการทดสอบ :</Label>
                      <p className="customer-type border border-1 py-1 px-3 rounded-pill w-100 text-center">
                        {borrowDetailtestdata.time
                          ? borrowDetailtestdata.time
                          : "-"}
                      </p>
                    </FormGroup>

                    {borrowDetailtestdata.newstartDate != null ? (
                      <div>
                        <Label className="">ระยะเวลาที่ดำเนินการทดสอบ (เก่า)</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            วันที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetailtestdata.oldstartDate
                                ? borrowDetailtestdata.oldstartDate
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            ถึง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetailtestdata.oldendDate
                                ? borrowDetailtestdata.oldendDate
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                        <Label className="">ระยะเวลาที่ดำเนินการทดสอบ (ใหม่)</Label>

                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            วันที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetailtestdata.newstartDate
                                ? borrowDetailtestdata.newstartDate
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            ถึง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetailtestdata.newendDate
                                ? borrowDetailtestdata.newendDate
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    ) : (
                      <div>
                        <Label className="">ระยะเวลาที่ดำเนินการทดสอบ</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            วันที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetailtestdata.oldstartDate
                                ? borrowDetailtestdata.oldstartDate
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            ถึง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {borrowDetailtestdata.oldendDate
                                ? borrowDetailtestdata.oldendDate
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    )}

                    {newAddressdatas?.newAddressNo != null ? (
                      <div>
                        <Label className="mt-1">สถานที่ดำเนินการทดสอบ (เก่า)</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            เลขที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldAddressNo
                                ? oldAddresstestdata.oldAddressNo
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            หมู่ที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldMoo
                                ? oldAddresstestdata.oldMoo
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="soi" sm={2}>
                            ซอย
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldSoi
                                ? oldAddresstestdata.oldSoi
                                : "-"}
                            </p>
                          </Col>

                          <Label for="street" sm={2}>
                            ถนน
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldStreet
                                ? oldAddresstestdata.oldStreet
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="province" sm={2}>
                            จังหวัด
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldProvince
                                ? oldAddresstestdata.oldProvince
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            อำเภอ/เขต
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldAmphur
                                ? oldAddresstestdata.oldAmphur
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="tumbon" sm={2}>
                            ตำบล/แขวง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldTumbon
                                ? oldAddresstestdata.oldTumbon
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            รหัสไปรษณีย์
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldPostCode
                                ? oldAddresstestdata.oldPostCode
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <Label className="mt-1">สถานที่ดำเนินการทดสอบ (ใหม่)</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            เลขที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newAddressNo
                                ? newAddresstestdata.newAddressNo
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            หมู่ที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newMoo
                                ? newAddresstestdata.newMoo
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="soi" sm={2}>
                            ซอย
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newSoi
                                ? newAddresstestdata.newSoi
                                : "-"}
                            </p>
                          </Col>

                          <Label for="street" sm={2}>
                            ถนน
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newStreet
                                ? newAddresstestdata.newStreet
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="province" sm={2}>
                            จังหวัด
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newProvince
                                ? newAddresstestdata.newProvince
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            อำเภอ/เขต
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newAmphur
                                ? newAddresstestdata.newAmphur
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="tumbon" sm={2}>
                            ตำบล/แขวง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newTumbon
                                ? newAddresstestdata.newTumbon
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            รหัสไปรษณีย์
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {newAddresstestdata.newPostCode
                                ? newAddresstestdata.newPostCode
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    ) : (
                      <div>
                        <Label className="mt-1">สถานที่ดำเนินการทดสอบ</Label>
                        <FormGroup row className="m-3">
                          <Label for="addNo" sm={2}>
                            เลขที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldAddressNo
                                ? oldAddresstestdata.oldAddressNo
                                : "-"}
                            </p>
                          </Col>

                          <Label for="moo" sm={2}>
                            หมู่ที่
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldMoo
                                ? oldAddresstestdata.oldMoo
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="soi" sm={2}>
                            ซอย
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldSoi
                                ? oldAddresstestdata.oldSoi
                                : "-"}
                            </p>
                          </Col>

                          <Label for="street" sm={2}>
                            ถนน
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldStreet
                                ? oldAddresstestdata.oldStreet
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="province" sm={2}>
                            จังหวัด
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldProvince
                                ? oldAddresstestdata.oldProvince
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            อำเภอ/เขต
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldAmphur
                                ? oldAddresstestdata.oldAmphur
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>

                        <FormGroup row className="m-3">
                          <Label for="tumbon" sm={2}>
                            ตำบล/แขวง
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldTumbon
                                ? oldAddresstestdata.oldTumbon
                                : "-"}
                            </p>
                          </Col>

                          <Label for="amphur" sm={2}>
                            รหัสไปรษณีย์
                          </Label>
                          <Col sm={4}>
                            <p className="customer-type border border-1 py-1 rounded-pill w-100 text-center">
                              {oldAddresstestdata.oldPostCode
                                ? oldAddresstestdata.oldPostCode
                                : "-"}
                            </p>
                          </Col>
                        </FormGroup>
                      </div>
                    )}


                  </div>
                ) : (
                  <div className="d-flex w-100 align-items-center justify-content-center">
                    <p>ไม่มีคำขอแจ้งเลื่อนการทดสอบมาตรฐานฝีมือแรงงาน</p>
                  </div>
                )}



              </div>

              <div className="d-flex align-items-center justify-content-center w-100 mb-3">
                <button
                  onClick={() => {
                    navigate(
                      `/borrowing/ExtendBorrowCheck?req=${searchParams.get(
                        "req"
                      )}`
                    );
                  }}
                  className="btn-blue p-2 w-50"
                >
                  ย้อนกลับ
                </button>
              </div>
            </>
          ) : (
            <Loading />
          )}
        </div>
      </Container>
    </>
  );
}
